<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>
    </el-form>
    <!--上传图片-->
    <div class="common-form">收款二维码</div>
    <div class="draggable-list">
      <draggable class="wrapper" v-model="form.image">
        <transition-group>
          <div class="item" v-for="(item, index) in form.image" :key="item.filePath">
            <img v-img-url="item.filePath" />
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
          </div>
        </transition-group>
      </draggable>
      <div class="item img-select" v-if="form.image.length == 0" @click="openProductUpload('image', 'image')"><i class="el-icon-plus"></i></div>
    </div>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="selectorConfig" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import FileApi from '@/api/file.js';
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  import {
    formatModel
  } from '@/utils/base.js';
  export default {
    components: {
      Upload,
      draggable
    },
    data() {
      return {
        isProductUpload: false,
        /*是否正在加载*/
        loading: false,
        /*form表单数据*/
        form: {
          image: [],
        },
        all_type: [],
        delivery_type: [],
        /*是否打开图片选择*/
        isupload: true,
        selectorConfig: {
          total: 1,
          multiple: false,
          fileType: "image",
        },
      };
    },
    created() {
      this.getParams()
    },

    methods: {
      getParams() {
        let self = this;
        SettingApi.getReceiptCode({}, true)
          .then(res => {
            if(res.data.image){
              self.form.image = res.data.image
            }
            self.show = true
          })
          .catch(error => {});
      },


      /*提交*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.editReceiptCode(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '设置成功',
              type: 'success'
            });
          })
          .catch(error => {
            self.loading = false;
          });

      },

      // 上传图片
      UploadImage(param) {
        let self = this;
        const loading = this.$loading({
          lock: true,
          text: '文件上传中,请等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const formData = new FormData();
        formData.append('iFile', param.file);
        formData.append("groupId", 0);
        formData.append("fileType", 'image');
        FileApi.uploadFile(formData)
          .then(response => {
            self.form.imageUrl = response.data
            loading.close();
          })
      },
      beforeAvatarUpload(file) {
        const typeArry = ['.jpeg', '.jpg', '.png', '.bmp', '.JPG', '.PNG', '.BMP', '.gif', '.GIF'];
        const type = file.name.substring(file.name.lastIndexOf('.'));
        const isImage = typeArry.indexOf(type) > -1;
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isImage) {
          this.$message.error('上传文件必须为图片');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isImage && isLt2M;
      },
      /*删除商品图片*/
      deleteImg(index) {
        this.form.image.splice(index, 1);
      },
      /*打开上传图片*/
      openProductUpload: function(file_type, file_name) {
        this.file_name = file_name;
        if (file_type == 'image') {
          this.config = {
            total: 9,
            fileType: 'image'
          };
        } else {
          this.config = {
            total: 1,
            fileType: 'video'
          };
        }
        this.isProductUpload = true;
      },
      /*上传商品图片*/
      returnProductImgsFunc(e) {
        if (e != null) {
          if (this.file_name == 'video') {
            this.form.videoId = e[0].fileId;
            this.form.videoFilePath = e[0].filePath;
          } else if (this.file_name == 'image') {
            let imgs = this.form.image.concat(e);
            // 兼容后端
            for (let i = 0; i < imgs.length; i++) {
              if (typeof(imageId) == "undefined") {
                this.$set(imgs[i], 'imageId', imgs[i].fileId);
              }
            }
            this.$set(this.form, 'image', imgs);
          } else if (this.file_name == 'poster') {
            this.form.posterId = e[0].fileId;
            this.form.posterFilePath = e[0].filePath;
          }
        }
        this.isProductUpload = false;
      }
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }

  .avatar-uploader {
    margin: 0 0 30px 150px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    /* height: 178px; */
    display: block;
  }

  .draggable-list .wrapper>span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/receiptcode/index.vue